import AccountHandler from "chits-data/dist/AccountHandler";
import { IAccount, emptyAccount, IAccountRoles, emptyAccountRoles } from "components/account/IAccount";
import Constants from "components/utils/constants";
// import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import mapDispatchToProps from "reducers/actions/dispatchProps";
import mapStateToProps from "reducers/actions/stateToProps";
import { IWalletState } from "reducers/walletReducer";
import { WebClientStore } from "web-client-store";

interface RedirectState {
  accountId: string;
  pageId: string;
  account: IAccount;
  roles: IAccountRoles;
//   accounts: [IAc]
}

interface RedirectProps {
  match: { params: { accountId: string; pageId: string } };
  accounts: [IAccount],
  wallet: IWalletState,
  setCurrentAccount: (account: IAccount) => void;
}

class Redirect extends React.Component<RedirectProps, RedirectState> {
    _handler: AccountHandler;
    constructor(props: RedirectProps) {
        super(props)
        this._handler = new AccountHandler();
    }
  state: Readonly<RedirectState> = {
    accountId: "",
    pageId: "dashboard",
    account: emptyAccount,
    roles: emptyAccountRoles
  };
    static propTypes: {};

  componentDidMount(): void {
    let _state: RedirectState = this.state;
    try {
      const {
        match: { params },
      } = this.props;
      if (params.accountId) {
        WebClientStore.Session.set(
          Constants.SESSION_KEYS.ACTIVE_ACCOUNT,
          params.accountId
        );
        _state.accountId = params.accountId;
      }
      if (params.pageId) {
        _state.pageId = params.pageId;
      }
    //   this.setState(_state);

        this.handleGetAccounts(_state.accountId)
    } catch (error) {
      console.log(error);
    }



    // TODO: Once below block is ready delete it from app.js
    // let ac = this._handler.getActiveAccount();
    // // asynchronously load account information to props
    // this._handler.getAccountCached(ac).then((account)=>{
    //     if (account) {
    //         console.debug('seeting current account', account);
    //         this.props.setCurrentAccount(account);
    //     } else {
    //         console.debug('current account NOT READY yet');
    //     }
    // })
  }

  handleGetAccounts = async (_id:string="", unset=false) => {
    let _accountLineup = [];
    // let _roles = this.state.roles;
    let defaultAccount = Constants.DEFAULT_ACCOUNT;
    let requested = defaultAccount;
    // let retrieveFrom = Constants.URLs.ACCOUNTS;
    // this.setState({ openOverlay: true });
    this._handler.getAccountsCached(unset).then((accounts: [IAccount]) => {
        // Display only ACTIVE accounts; sorted by type
        let _accounts = Constants.sortAccountsByType(accounts.filter(ac=>{
            let isValid = ac.type === "CHIT";
            // if (ac.type === "CHIT") {
            //     isValid = ac.chit_info && ac.chit_info.nextTerm && ac.chit_info.nextTerm > 0;
            // }
            return isValid
            // return ac.status==="ac" && isValid
        }));
        this.processAccountSelection(_id, _accounts);
        // _accountLineup = _concat(defaultAccount, _accounts);
        // let activeAccountId = Session.get(SESSION_KEYS.ACTIVE_ACCOUNT);
        // if (activeAccountId !== undefined && activeAccountId !== '') {
        //     requested = accounts.filter((item) => {
        //         if(this.props.caller && this.props.caller === "AccountInfo") {
        //             return item._id === activeAccountId;
        //         } else {
        //             //Any page other than account info must be restricted to non-active accounts
        //             return item._id === activeAccountId && item.status === 'ac';
        //         }
        //     })[0];
        // }
        // console.log('identified object by the supplied param is:' + JSON.stringify(requested));
        // if (!requested) {
        //     requested = defaultAccount;
        //     this.props.enqueueSnackbar('Requested account is not accessible. Please chose a valid account.', {
        //         variant: 'warning'
        //     });
        // } else {
        //     if (requested && requested.hasOwnProperty('curr') && requested.curr !== '') {
        //         Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_CURR, requested.curr);
        //     }
        //     if (requested && requested.hasOwnProperty('type') && requested.type !== '') {
        //         Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE, requested.type);
        //     }
        //     _roles.owner = requested.isOwner || false;
        //     _roles.admin = requested.isAdmin || false;
        //     _roles.editor = requested.isEditor || false;
        //     _roles.viewer = requested.isViewer || false;
        //     _roles.any = requested.isOwner || requested.isAdmin || requested.isEditor || requested.isViewer;
        // }
        
        // this.setState({
        //     openOverlay: false,
        //     roles: _roles,
        //     selectedAccount: requested,
        //     accounts: _accountLineup
        // })
        // this.props.onReady(_accountLineup, requested, _roles);
    })
}

    processAccountSelection = (id: string, _accounts: [IAccount]) => {
        if (id === 'unknown') {
            //do nothing
            return;
        }
        // let _accounts: [IAccount] = this.props.accounts;
        //Session.set(SESSION_KEYS.ACTIVE_ACCOUNT, id);
        let _account = _accounts.filter((item) => {
            return item._id === id;
        })[0];
        if (_account && _account.hasOwnProperty('curr') && _account.curr !== '') {
            //Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_CURR, account.curr);
        }
        if (_account && _account.hasOwnProperty('type') && _account.type !== '') {
            //Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE, account.type);
        }
        let _roles:IAccountRoles = emptyAccountRoles;
        _roles.owner = _account.isOwner || false;
        _roles.admin = _account.isAdmin || false;
        _roles.editor = _account.isEditor || false;
        _roles.viewer = _account.isViewer || false;
        _roles.any = _account.isOwner || _account.isAdmin || _account.isEditor || _account.isViewer;
        // this.setState({
        //     selectedAccount: account,
        //     roles: _roles
        // });
        this.handleAccountSelection(_accounts, _account, _roles);
    }



  handleAccountSelection = (accounts:[IAccount], ac:IAccount, roles:IAccountRoles) => {
    // console.log('AccountInfo->renderActionInfoForm->AFTER ac', ac);
    let {type, chit_info} = ac;
    // if (type !== "CHIT") return;
    let {nextTerm, chit_tenure} = chit_info;
    // TODO: Move below business logic into a dedicated module/service
    let _currentChitTerm = 1;
    let _maxTerms = 1;
    if (nextTerm && nextTerm > 0) {
        _currentChitTerm = nextTerm - 1;
        _maxTerms = nextTerm - 1;
    } else {
        _currentChitTerm = chit_tenure;
        _maxTerms = chit_tenure;
    }
    this.setState({ account: ac, accountId: ac._id, roles })
    console.debug('wallet(before)', JSON.stringify(this.props.wallet.current.name))
    this.props.setCurrentAccount(ac);
    console.debug('wallet(after)', JSON.stringify(this.props.wallet.current.name))

    setTimeout(function () {
      window.location.replace("/info");
    }, 600);
    // this.setState({
    //     enabledAdd: ((roles.owner || roles.admin || roles.editor) && ac.code !== 'unknown' && ac.type !== 'CHIT'),
    //     filters: _cloneDeep(defaultFilter),
    //     accountLineUp: accounts,
    //     selectedAccount: ac,
    //     roles,
    //     currentChitTerm: _currentChitTerm,
    //     maxTerms: _maxTerms
    // })
    // if (ac._id !== 'unknown') {
    //     this.handleGetListItems(true);
    // }
}

  render(): React.ReactNode {
    return (
        <>
        <span>
            You are being redirected to page [{this.state.pageId}] for the selected
            chitfund [{this.state.account.name}]...
        </span>
        </>
    );
  }
}

// Redirect.propTypes = {
//     // match: PropTypes.object,
//     accounts: PropTypes.array.isRequired
// }

export default connect(mapStateToProps, mapDispatchToProps)(Redirect);
